// NEW STYPEPARAMS METHOD
var THUMBNAILS_ALIGNMENT = {
    BOTTOM: 'BOTTOM',
    LEFT: 'LEFT',
    TOP: 'TOP',
    RIGHT: 'RIGHT',
};
export default THUMBNAILS_ALIGNMENT;
//# sourceMappingURL=layoutParams_thumbnails_alignment.js.map